module.exports = __webpack_public_path__ + "img/main_dsw.ed5c39c3.jpg";